var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 3.75,
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20841 3.12484C5.20841 3.2399 5.11514 3.33317 5.00008 3.33317C4.88502 3.33317 4.79175 3.2399 4.79175 3.12484C4.79175 3.00978 4.88502 2.9165 5.00008 2.9165C5.11514 2.9165 5.20841 3.00978 5.20841 3.12484Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.08317V4.1665",
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49976 3C5.49976 3.27614 5.2759 3.5 4.99976 3.5C4.72361 3.5 4.49976 3.27614 4.49976 3C4.49976 2.72386 4.72361 2.5 4.99976 2.5C5.2759 2.5 5.49976 2.72386 5.49976 3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLight);
export default __webpack_public_path__ + "static/media/info_light.bcbd3f97fad5bbb74015e9c6d6bb5d52.svg";
export { ForwardRef as ReactComponent };